export default "__VITE_ASSET__DN7XSu85__"